/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceBase,
  BalanceBaseOptional,
  BalanceBaseMetaI,
  BalanceBaseTrackedI,
} from "./balance-base";
import { BalanceBaseTracked, BalanceBaseMeta } from "./balance-base";
// May contain unused imports in some cases
// @ts-ignore
import type {
  BalanceType,
  BalanceTypeOptional,
  BalanceTypeMetaI,
  BalanceTypeTrackedI,
} from "./balance-type";
import { BalanceTypeTracked, BalanceTypeMeta } from "./balance-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  Deletable,
  DeletableOptional,
  DeletableMetaI,
  DeletableTrackedI,
} from "./deletable";
import { DeletableTracked, DeletableMeta } from "./deletable";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonBalanceBase,
  PersonBalanceBaseOptional,
  PersonBalanceBaseMetaI,
  PersonBalanceBaseTrackedI,
} from "./person-balance-base";
import {
  PersonBalanceBaseTracked,
  PersonBalanceBaseMeta,
} from "./person-balance-base";

/**
 *
 * @export
 * @interface BalanceFull
 */
export interface BalanceFullOptional extends BalanceBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceFull
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceName?: string;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceExpirationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceAccountNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  balanceIsPrivate?: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceFull
   */
  balanceType?: BalanceType;
  /**
   *
   * @type {Array<PersonBalanceBase>}
   * @memberof BalanceFull
   */
  personBalances?: PersonBalanceBaseOptional[];
  /**
   *
   * @type {number}
   * @memberof BalanceFull
   */
  balanceMinimumCents?: number;
}

export interface BalanceFull
  extends BalanceFullOptional, BalanceBase, Deletable {
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceFull
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceName?: string;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceExpirationDate?: Date;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceAccountNumber?: string;
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  balanceIsPrivate?: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceFull
   */
  balanceType: BalanceType;
  /**
   *
   * @type {Array<PersonBalanceBase>}
   * @memberof BalanceFull
   */
  personBalances?: PersonBalanceBase[];
  /**
   *
   * @type {number}
   * @memberof BalanceFull
   */
  balanceMinimumCents?: number;
}

export interface BalanceFullTrackedI extends BalanceBaseOptional {
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceFull
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceName?: string;
  balanceNameIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceExpirationDate?: Date;
  balanceExpirationDateIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof BalanceFull
   */
  balanceAccountNumber?: string;
  balanceAccountNumberIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof BalanceFull
   */
  balanceIsPrivate?: boolean;
  balanceIsPrivateIsSet: boolean;
  /**
   *
   * @type {BalanceType}
   * @memberof BalanceFull
   */
  balanceType?: BalanceType;
  balanceTypeIsSet: boolean;
  /**
   *
   * @type {Array<PersonBalanceBase>}
   * @memberof BalanceFull
   */
  personBalances?: PersonBalanceBaseTrackedI[];
  personBalancesIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof BalanceFull
   */
  balanceMinimumCents?: number;
  balanceMinimumCentsIsSet: boolean;
}

transformDatesMap.set("BalanceFull", function (model: BalanceFull) {
  if (typeof model.balanceExpirationDate == "string")
    model.balanceExpirationDate = new Date(model.balanceExpirationDate);
  const transformDatespersonBalances =
    transformDatesMap.get("PersonBalanceBase");
  if (transformDatespersonBalances) {
    model.personBalances?.forEach((sub) => {
      transformDatespersonBalances(sub);
    });
  }
});

export type BalanceFullMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  balanceName: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: true
  balanceExpirationDate: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  balanceAccountNumber: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  balanceIsPrivate: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  balanceType: PropertyMeta<BalanceTypeMetaI>;
  //isDate: false
  //isDatetime: false
  personBalances: PropertyMeta<PersonBalanceBaseMetaI>;
  //isDate: false
  //isDatetime: false
  balanceMinimumCents: PropertyMeta<MetaTypeBase<number>>;
}>;

export var BalanceFullMeta: BalanceFullMetaI = {} as BalanceFullMetaI;
BalanceFullMeta = typeMeta("BalanceFull", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  balanceName: propertyMeta(
    "balanceName",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  balanceExpirationDate: propertyMeta(
    "balanceExpirationDate",
    false,
    false,
    false,
    MetaTypesBase.Date,
  ),
  balanceAccountNumber: propertyMeta(
    "balanceAccountNumber",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  balanceIsPrivate: propertyMeta(
    "balanceIsPrivate",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  balanceType: propertyMeta("balanceType", false, true, false, BalanceTypeMeta),
  personBalances: propertyMeta(
    "personBalances",
    true,
    false,
    false,
    PersonBalanceBaseMeta,
  ),
  balanceMinimumCents: propertyMeta(
    "balanceMinimumCents",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = BalanceFullMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([DeletableMeta]);
  metaI.isDeleted.inheritedFrom = DeletableMeta.isDeleted;
  metaI.isNew.inheritedFrom = DeletableMeta.isNew;
  metaI.interfaces = metaI.interfaces.concat([BalanceBaseMeta]);
  metaI.assignId.inheritedFrom = BalanceBaseMeta.assignId;
  metaI.balanceName.inheritedFrom = BalanceBaseMeta.balanceName;
  metaI.balanceExpirationDate.inheritedFrom =
    BalanceBaseMeta.balanceExpirationDate;
  metaI.balanceAccountNumber.inheritedFrom =
    BalanceBaseMeta.balanceAccountNumber;
  metaI.balanceIsPrivate.inheritedFrom = BalanceBaseMeta.balanceIsPrivate;
  metaI.balanceType.inheritedFrom = BalanceBaseMeta.balanceType;
});

export class BalanceFullTracked
  extends BalanceBaseTracked
  implements BalanceFullTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  balanceName__I?: string = undefined;
  balanceNameIsSet: boolean = false;
  set balanceName(v: undefined | string) {
    if (v !== undefined) {
      this.balanceName__I = v;
      this.balanceNameIsSet = true;
    } else {
      this.balanceName__I = v || undefined;
      this.balanceNameIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceName() {
    return this.balanceName__I;
  }
  balanceExpirationDate__I?: Date = undefined;
  balanceExpirationDateIsSet: boolean = false;
  set balanceExpirationDate(v: undefined | Date) {
    if (v !== undefined) {
      this.balanceExpirationDate__I = v;
      this.balanceExpirationDateIsSet = true;
    } else {
      this.balanceExpirationDate__I = v || undefined;
      this.balanceExpirationDateIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceExpirationDate() {
    return this.balanceExpirationDate__I;
  }
  balanceAccountNumber__I?: string = undefined;
  balanceAccountNumberIsSet: boolean = false;
  set balanceAccountNumber(v: undefined | string) {
    if (v !== undefined) {
      this.balanceAccountNumber__I = v;
      this.balanceAccountNumberIsSet = true;
    } else {
      this.balanceAccountNumber__I = v || undefined;
      this.balanceAccountNumberIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceAccountNumber() {
    return this.balanceAccountNumber__I;
  }
  balanceIsPrivate__I?: boolean = undefined;
  balanceIsPrivateIsSet: boolean = false;
  set balanceIsPrivate(v: undefined | boolean) {
    if (v !== undefined) {
      this.balanceIsPrivate__I = v;
      this.balanceIsPrivateIsSet = true;
    } else {
      this.balanceIsPrivate__I = v || undefined;
      this.balanceIsPrivateIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceIsPrivate() {
    return this.balanceIsPrivate__I;
  }
  balanceType__I?: BalanceType = undefined;
  balanceTypeIsSet: boolean = false;
  set balanceType(v: undefined | BalanceType) {
    if (v !== undefined) {
      this.balanceType__I = v;
      this.balanceTypeIsSet = true;
    } else {
      this.balanceType__I = v || undefined;
      this.balanceTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get balanceType() {
    return this.balanceType__I;
  }
  personBalances__I?: PersonBalanceBaseTracked[] = undefined;
  personBalancesIsSet: boolean = false;
  set personBalances(v: undefined | PersonBalanceBaseTracked[]) {
    if (v !== undefined) {
      this.personBalances__I = v;
      this.personBalancesIsSet = true;
    } else {
      this.personBalances__I = v || undefined;
      this.personBalancesIsSet = false;
    }
    this.changeTracker = true;
  }
  get personBalances() {
    return this.personBalances__I;
  }
  balanceMinimumCents__I?: number = undefined;
  balanceMinimumCentsIsSet: boolean = false;
  set balanceMinimumCents(v: undefined | number) {
    if (v !== undefined) {
      this.balanceMinimumCents__I = v;
      this.balanceMinimumCentsIsSet = true;
    } else {
      this.balanceMinimumCents__I = v || undefined;
      this.balanceMinimumCentsIsSet = false;
    }
    this.changeTracker = true;
  }
  get balanceMinimumCents() {
    return this.balanceMinimumCents__I;
  }
  constructor(config?: BalanceFullOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.personBalances?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: BalanceFullOptional,
    options?: AssignOptions,
  ): BalanceFullTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (
      config.balanceName &&
      this.balanceNameApplyFilter(optionsRequired.filter)
    ) {
      this.balanceName = config.balanceName;
      if (optionsRequired.unassign) this.balanceNameIsSet = false;
      else this.balanceNameIsSet = true;
    }
    if (
      config.balanceExpirationDate &&
      this.balanceExpirationDateApplyFilter(optionsRequired.filter)
    ) {
      this.balanceExpirationDate = config.balanceExpirationDate;
      if (optionsRequired.unassign) this.balanceExpirationDateIsSet = false;
      else this.balanceExpirationDateIsSet = true;
    }
    if (
      config.balanceAccountNumber &&
      this.balanceAccountNumberApplyFilter(optionsRequired.filter)
    ) {
      this.balanceAccountNumber = config.balanceAccountNumber;
      if (optionsRequired.unassign) this.balanceAccountNumberIsSet = false;
      else this.balanceAccountNumberIsSet = true;
    }
    if (
      config.balanceIsPrivate &&
      this.balanceIsPrivateApplyFilter(optionsRequired.filter)
    ) {
      this.balanceIsPrivate = config.balanceIsPrivate;
      if (optionsRequired.unassign) this.balanceIsPrivateIsSet = false;
      else this.balanceIsPrivateIsSet = true;
    }
    if (
      config.balanceType &&
      this.balanceTypeApplyFilter(optionsRequired.filter)
    ) {
      this.balanceType = config.balanceType;
      if (optionsRequired.unassign) this.balanceTypeIsSet = false;
      else this.balanceTypeIsSet = true;
    }
    if (
      config.personBalances &&
      this.personBalancesApplyFilter(optionsRequired.filter)
    ) {
      this.personBalances = config.personBalances?.map(
        (a) => new PersonBalanceBaseTracked(a, options),
      );
      if (optionsRequired.unassign) this.personBalancesIsSet = false;
      else this.personBalancesIsSet = true;
    }
    if (
      config.balanceMinimumCents &&
      this.balanceMinimumCentsApplyFilter(optionsRequired.filter)
    ) {
      this.balanceMinimumCents = config.balanceMinimumCents;
      if (optionsRequired.unassign) this.balanceMinimumCentsIsSet = false;
      else this.balanceMinimumCentsIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): BalanceFullTrackedI {
    const cloned = {} as BalanceFullTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.balanceNameIsSetDeep() &&
      this.balanceNameApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceNameIsSet = true;
      cloned.balanceName = this.balanceName;
    } else {
      //cloned.balanceNameIsSet = false
    }
    if (
      this.balanceExpirationDateIsSetDeep() &&
      this.balanceExpirationDateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceExpirationDateIsSet = true;
      cloned.balanceExpirationDate = this.balanceExpirationDate;
    } else {
      //cloned.balanceExpirationDateIsSet = false
    }
    if (
      this.balanceAccountNumberIsSetDeep() &&
      this.balanceAccountNumberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceAccountNumberIsSet = true;
      cloned.balanceAccountNumber = this.balanceAccountNumber;
    } else {
      //cloned.balanceAccountNumberIsSet = false
    }
    if (
      this.balanceIsPrivateIsSetDeep() &&
      this.balanceIsPrivateApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceIsPrivateIsSet = true;
      cloned.balanceIsPrivate = this.balanceIsPrivate;
    } else {
      //cloned.balanceIsPrivateIsSet = false
    }
    if (
      this.balanceTypeIsSetDeep() &&
      this.balanceTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceTypeIsSet = true;
      cloned.balanceType = this.balanceType;
    } else {
      //cloned.balanceTypeIsSet = false
    }
    if (
      this.personBalancesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.personBalancesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personBalancesIsSet = true;
      cloned.personBalances = this.personBalances
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.personBalancesIsSet = false
    }
    if (
      this.balanceMinimumCentsIsSetDeep() &&
      this.balanceMinimumCentsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.balanceMinimumCentsIsSet = true;
      cloned.balanceMinimumCents = this.balanceMinimumCents;
    } else {
      //cloned.balanceMinimumCentsIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): BalanceFullTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.balanceNameApplyFilter(filter)) this.balanceNameIsSet = false;

    if (!this.balanceExpirationDateApplyFilter(filter))
      this.balanceExpirationDateIsSet = false;

    if (!this.balanceAccountNumberApplyFilter(filter))
      this.balanceAccountNumberIsSet = false;

    if (!this.balanceIsPrivateApplyFilter(filter))
      this.balanceIsPrivateIsSet = false;

    if (!this.balanceTypeApplyFilter(filter)) this.balanceTypeIsSet = false;

    if (!this.personBalancesApplyFilter(filter))
      this.personBalancesIsSet = false;

    this.personBalances?.forEach((a) => a.unassignAll(filter));
    if (!this.balanceMinimumCentsApplyFilter(filter))
      this.balanceMinimumCentsIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.isDeleted,
      BalanceFullMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(BalanceFullMeta.isNew, BalanceFullMeta, this.isNew, this);
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.assignId,
      BalanceFullMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  balanceNameApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.balanceName,
      BalanceFullMeta,
      this.balanceName,
      this,
    );
  }
  balanceNameIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceNameIsSet && this.balanceNameApplyFilter(filter))
      return true;

    return false;
  }
  balanceExpirationDateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.balanceExpirationDate,
      BalanceFullMeta,
      this.balanceExpirationDate,
      this,
    );
  }
  balanceExpirationDateIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceExpirationDateIsSet &&
      this.balanceExpirationDateApplyFilter(filter)
    )
      return true;

    return false;
  }
  balanceAccountNumberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.balanceAccountNumber,
      BalanceFullMeta,
      this.balanceAccountNumber,
      this,
    );
  }
  balanceAccountNumberIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceAccountNumberIsSet &&
      this.balanceAccountNumberApplyFilter(filter)
    )
      return true;

    return false;
  }
  balanceIsPrivateApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.balanceIsPrivate,
      BalanceFullMeta,
      this.balanceIsPrivate,
      this,
    );
  }
  balanceIsPrivateIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceIsPrivateIsSet && this.balanceIsPrivateApplyFilter(filter))
      return true;

    return false;
  }
  balanceTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.balanceType,
      BalanceFullMeta,
      this.balanceType,
      this,
    );
  }
  balanceTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.balanceTypeIsSet && this.balanceTypeApplyFilter(filter))
      return true;

    return false;
  }
  personBalancesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.personBalances,
      BalanceFullMeta,
      this.personBalances,
      this,
    );
  }
  personBalancesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personBalancesIsSet && this.personBalancesApplyFilter(filter))
      return true;

    return this.personBalances?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  balanceMinimumCentsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      BalanceFullMeta.balanceMinimumCents,
      BalanceFullMeta,
      this.balanceMinimumCents,
      this,
    );
  }
  balanceMinimumCentsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.balanceMinimumCentsIsSet &&
      this.balanceMinimumCentsApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.balanceNameIsSetDeep(filter)) return true;
    if (this.balanceExpirationDateIsSetDeep(filter)) return true;
    if (this.balanceAccountNumberIsSetDeep(filter)) return true;
    if (this.balanceIsPrivateIsSetDeep(filter)) return true;
    if (this.balanceTypeIsSetDeep(filter)) return true;
    if (this.personBalancesIsSetDeep(filter)) return true;
    if (this.balanceMinimumCentsIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
